import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import { EnrollmentMultiLayout } from '@egw/layouts'
import { GenericError } from '@egw/components'
import { Logger } from '@egw/logger'
import { type FC, useEffect } from 'react'
import { useGetEnrollmentMultiHomeData } from '@egw/api'
import { useTranslation } from '@egw/i18n'
import { screenRecordingService } from '@egw/screen-recording'
import { enrollmentCookieService } from '@egw/enrollment-cookie'
import { riskService } from '@egw/risk-service'
import { useValidateRoute } from '../../../hooks/navigation/validate-route'

const log = new Logger('Enrollment - Multi - Home')

export const HomePage: FC = () => {
  const { t } = useTranslation('features-enrollment')
  const sessionRecordingUrl = screenRecordingService.getSessionUrl()

  // Reset enrollment session before initiating application
  useEffect(() => {
    void enrollmentCookieService.resetSession()
    void riskService.updateFlow('enrollment')
  }, [])

  const { data, isLoading, error } = useGetEnrollmentMultiHomeData({
    initiateApplication: true,
    experimentId: 'MONTELOBOS',
    enrollmentMetadata: {
      sessionRecordingUrl,
      // Check if we need the rest of these - G
      // deviceInfo: deviceInfo,
      // platformInfo: platformInfo,
      // googleAnalytics,
    },
  })

  // Protect route
  useValidateRoute(data?.path)

  return (
    <EnrollmentMultiLayout>
      <div className="egw-container-enroll-multi h-full flex flex-col relative md:justify-center justify-start items-start">
        {/* Loading initial data to make sure the user has access to this screen and retreive data based on user enrollment application */}
        {isLoading ? (
          <SkeletonTheme baseColor="#eeefee" highlightColor="rgba(255, 255, 255, 0.5)">
            <Skeleton count={1} height="100px" className="mb-10" />
            <Skeleton count={5} height="50px" />
          </SkeletonTheme>
        ) : null}

        {/* This error handles the case when the initial data is not loaded, for example network error */}
        {error ? (
          <div className="flex-1 flex flex-col justify-start md:justify-center">
            <GenericError errorMessage={t('common.generic_error')} />
          </div>
        ) : null}
      </div>
    </EnrollmentMultiLayout>
  )
}
